import React from 'react';
import { Anchor, Users, MapPin, Star } from 'lucide-react';
import { features } from '../data/mock';

const iconMap = {
  Anchor: Anchor,
  Users: Users,
  MapPin: MapPin,
  Star: Star,
};

const FeaturesSection = () => {
  return (
    <section className="py-24 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4">
            Why Choose CC Yachting
          </h2>
          <p className="text-white/70 text-lg max-w-2xl mx-auto">
            Experience unparalleled luxury with our premium services
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div
                key={feature.id}
                className="group p-8 bg-gray-800/50 rounded-2xl border border-gray-700/50 hover:border-orange-500/50 transition-all duration-300 hover:-translate-y-1"
              >
                <div className="w-14 h-14 rounded-xl bg-orange-500/10 flex items-center justify-center mb-6 group-hover:bg-orange-500/20 transition-colors">
                  <IconComponent className="w-7 h-7 text-orange-500" />
                </div>
                <h3 className="text-xl font-semibold text-white mb-3">{feature.title}</h3>
                <p className="text-white/60 leading-relaxed">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
